enum TerminalType {
  Feig = 'feig',
  P400 = 'p400',
  Q30Pax = 'q30pax',
}

export default TerminalType;
